import React, { useState, useEffect } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Tabs, Tab, Grid, Divider, Typography } from "@material-ui/core";
import { SectionGridContainer } from "../../components/Layout";
import { useTestIds } from "../../hooks/useTestIds";
import RiderProfileRouter from "../../routers/RiderProfileRouter";

const useStyles = makeStyles((theme) => ({
  divider: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  noPadding: {
    padding: 0,
  },
  tab: {
    margin: `${theme.spacing(0.25)}px 0`,
  },
}));

export default function HistoryWidget() {
  const TABS = [
    { label: "reservations", path: "reservations" },
    { label: "group-reservations", path: "group-reservations" },
    { label: "transactions", path: "wallet/transactions" },
  ];

  const [currentTab, setCurrentTab] = useState(0);
  const testIds = useTestIds("rider-profile-history-widget");
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles(theme);
  const { riderId } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    TABS.forEach(({ label }, idx) => {
      if (location.pathname.toLowerCase().includes(`/${label}`)) {
        setCurrentTab(idx);
      }
    });
  }, [location]);

  const onChangeTab = (_, tab) => {
    setCurrentTab(tab);
    history.push(`/riders/${riderId}/${TABS[tab].path}`);
  };
  return (
    <SectionGridContainer
      spaceContents
      testId={testIds.wrapper}
      gridProps={{ xs: 12, sm: 7, md: 8, lg: 9 }}
      style={{ margin: 0, marginTop: theme.spacing(2), padding: 0 }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" data-testid={testIds.title}>
          {t("Riders.RiderProfile.RiderHistory")}
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.divider}>
        <Divider />
      </Grid>
      <Grid item xs={12} className={classes.noPadding}>
        <Tabs value={currentTab} onChange={onChangeTab} indicatorColor="secondary" centered>
          <Tab
            data-testid={testIds.reservationsTab}
            label={t("Riders.RiderProfile.Reservations")}
            className={classes.tab}
          />
          <Tab
            data-testid={testIds.groupReservationsTab}
            label={t("Riders.RiderProfile.GroupReservations")}
            className={classes.tab}
          />
          <Tab
            data-testid={testIds.transactionsTab}
            label={t("Riders.RiderProfile.Transactions")}
            className={classes.tab}
          />
        </Tabs>
        <Divider />
      </Grid>
      <RiderProfileRouter />
    </SectionGridContainer>
  );
}
